import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';
import { CompletedAssessmentsComponent } from '../completed-assessments/completed-assessments.component';
import { DownloadAssessmentManager } from '../../services/angular/DownloadAssessmentManager';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-client-assessments',
  templateUrl: './client-assessments.component.html',
    styleUrls: ['./client-assessments.component.scss'],
    providers: [CompletedAssessmentsComponent, DownloadAssessmentManager]
})
export class ClientAssessmentsComponent implements OnInit {

    constructor(
        private _Globals: Globals,
        private _CompletedAssessmentsComponent: CompletedAssessmentsComponent,
        private _toastr: ToastrService) { }

    ngOnInit() {
        if (this._Globals.coachResultsDisplayToast) {
            this._toastr.error('You are not authorized to access the requested page', 'ELI', {
                disableTimeOut: true
            });
            this._Globals.coachResultsDisplayToast = false;
        }
    }

    tabSelect(tabIndex: any) {
        tabIndex = parseInt(tabIndex);
        console.log(tabIndex);

        switch (tabIndex) {
            case 1: {
                this.executeSizeToFit(this._CompletedAssessmentsComponent, 0);
                break;
            }
        }
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 500);
    }

    executeSizeToFit(gridApi: any, tabIndex) {
        gridApi.sizeToFit(this._Globals.gridApis[tabIndex]);
    }

    ngOnDestroy() {
        this._Globals.gridApis = [];
    }
}
